import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getAuthorizationAPI from '../../../api/services/Authorizations/getAuthorization.service';
import BillingGrids from '../../../api/services/Billing/BillingGrid.service';
import InterventionDataById from '../../../api/services/Intervention/Service/InterventionDataById.service';
import getClaimHistoryAPI from '../../../api/services/MergeClaims/getClaimHistory';
import historyGrid from '../../../api/services/MetaDataManagement/historyGrid.service';
import paymentGridAPI from '../../../api/services/PaymentGrid/paymentGrid.service';
import ProgramBookHistoryAPI from '../../../api/services/ProgramBook/ProgramBookHistoryAPI.service';
import getSessionExistingNote from '../../../api/services/Session/getSessionExistingNote.service';

const initialState = {
  value: [],
  valueHistory: [],
  loading: false,
  heading: '',
  tab: '',
  sortingData: {},
  searchValue1: '',
  ID: '',
};
interface MyData {
  id?: any;
  heading: string;
  roleId: any;
  type: string;
  appointmentId?: any;
  ID?: any;
  assignedTo: any;
  pagination: {
    startIndex: number;
    noOfRecords: number;
  };
  order: string;
  name: string;
  filterValue: string;
  appointmentWith: string;
  publishStatus: string;
  isNotPaginated?: any;
  clientId?: string;
  date?: any;
  providerId?: any;
  authorizationCode?: any;
  organizationServicesId?: any;
  organizationInsuranceId?: any;
  diagnosisCodeId?: any;
  res?: any;
}
export const getActiveAsyncHistory = createAsyncThunk(
  'getActiveAsyncHistory',
  async (payload: MyData, { rejectWithValue }) => {
    switch (payload?.type) {
      case 'INTERVENTION_HISTORY':
        try {
          const res = await InterventionDataById.getInterventionPlanDataHistoryGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'CLAIM_HISTORY':
        try {
          const res = await getClaimHistoryAPI.getClaimHistory(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'PROGRAMBOOK_HISTORY':
        try {
          const res = await ProgramBookHistoryAPI.getProgramBookDataHistoryGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'PROGRAMBOOK_LIBRARY_HISTORY':
        try {
          const res = await ProgramBookHistoryAPI.getProgramBoolLibraryHistoryGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'SESSION_EXISTING_NOTE':
        try {
          const res = await getSessionExistingNote.getSessionExistingNoteApi(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'Billing Amount':
        try {
          const res = await paymentGridAPI.paymentGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'BILLING_HISTORY':
        try {
          const res = await BillingGrids.getBillingGridHistory(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'Diagnosis Codes':
        try {
          const res = await historyGrid.diagnosisCodeHistoryGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'Payor History':
        try {
          const res = await getAuthorizationAPI.payorHistory(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'Insurances':
        try {
          const res = await historyGrid.insuranceHistoryGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'Services':
        try {
          const res = await historyGrid.servicesHistoryGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'Email Format':
        try {
          const res = await historyGrid.emailHistoryGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'SessionDetails':
        try {
          const res = await historyGrid.sessionDetailsGrid(payload);
          return res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;
      case 'TerminateSessionDetails':
        try {
          return payload.res.data;
        } catch (err) {
          rejectWithValue('Error in Response');
        }
        break;

      default:
        break;
    }
  }
);
const getHistory = createSlice({
  name: 'getHistory',
  initialState,
  reducers: {
    savingData: (state, action) => {
      state.value = { ...action.payload };
    },
    savingHeading: (state, action) => {
      state.heading = { ...action.payload };
    },
    savingTabData1: (state, action) => {
      state.tab = action.payload.tab;
    },
    savingSearchData: (state, action) => {
      state.searchValue1 = action.payload.searchValue1;
    },
    savingInterventionId: (state, action) => {
      state.ID = action.payload.ID;
    },
    savingSortingData: (state, action) => {
      state.sortingData = action.payload.sortingData;
    },
    resetData: state => {
      state.value = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getActiveAsyncHistory.pending, (state: any) => {
        state.loading = true;
        state.value = [];
      })
      .addCase(getActiveAsyncHistory.fulfilled, (state: any, action) => {
        state.value = action.payload;
        state.loading = false;
      })
      .addCase(getActiveAsyncHistory.rejected, (state: any) => {
        state.loading = false;
        state.value = [];
      });
  },
});
// Action creators are generated for each case reducer function
export const {
  savingInterventionId,
  savingData,
  savingTabData1,
  savingSortingData,
  savingHeading,
  savingSearchData,
  resetData,
} = getHistory.actions;
export default getHistory.reducer;
